// react
import * as React from 'react';
import { connect } from 'react-redux';

// material-ui
import { Paper, Button, Typography } from '@material-ui/core';
import withTheme, { WithTheme } from '@material-ui/core/styles/withTheme';

// project files
import { AscendState } from '../../ducks';
import Title from '../shared/Title/Title';
import Layout from '../Layout/Layout';

type UserProps = {
  guid: string;
  lastQuizUrl?: string;
  lastResultsUrl?: string;
};

const QuizResults = ({ guid, lastQuizUrl, lastResultsUrl }: UserProps & WithTheme) => {
  const hasQuizUrl = lastQuizUrl && lastQuizUrl.trim() !== '';
  const hasResultsUrl = lastResultsUrl && lastResultsUrl.trim() !== '';

  const buttonSection = hasQuizUrl ? (
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => window.open(lastQuizUrl, '_blank', 'noopener,noreferrer')}>
        Edit Answers
      </Button>
    </div>
  ) : (
    <></>
  );

  return (
    <Layout>
      <Title text={'Calculator Results'} center />
      {buttonSection}
      <Paper elevation={3} style={{ padding: 10, overflow: 'hidden' }}>
        {hasResultsUrl ? (
          <iframe
            src={`${lastResultsUrl}?user_guid=${guid}&showHeader=0&showFooter=0`}
            width="100%"
            height="800"
            frameBorder="0"
          />
        ) : (
          <div style={{ padding: '2rem', textAlign: 'center' }}>
            <Typography variant="h6" color="textSecondary">
              Quiz results are not available at this time.
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: '1rem' }}>
              Please contact support if you believe this is an error.
            </Typography>
          </div>
        )}
      </Paper>
    </Layout>
  );
};

const mapStateToProps = (state: AscendState) => ({
  guid: state.user.data.guid,
  // signupMapping: state.user.data.signupMapping, //not used anymore leaving here for now
  lastQuizUrl: state.user.data.lastQuizUrl,
  lastResultsUrl: state.user.data.lastResultsUrl,
});
export default withTheme()(connect<UserProps>(mapStateToProps)(QuizResults));
